import { createBrowserRouter } from 'react-router-dom';
// import MainRoutes from './route-main';
import MainRoutes from './route-main';
import LoginRoutes from './route-main/route-public/LoginRoutes';
// For demo example components by Rubber
import ComponentsRoutes from './route-main/route-public/ComponentsRoutes';
import ExampleRoutes from './route-main/route-public/ExampleRoutes';
import ExampleBackendRoute from './route-main/route-public/ExampleBackendRoute';

// ==============================|| ROUTES RENDER ||============================== //

const router = createBrowserRouter([MainRoutes, LoginRoutes, ComponentsRoutes, ExampleRoutes, ExampleBackendRoute], {
  basename: import.meta.env.VITE_APP_BASE_NAME
});

export default router;
